<template>

</template>

<script>
    export default {
        name: '03points',
        mounted() {
            window.location.href = "https://service.beidouwatch.com/bdwatch_web/view/myPoints.html?userId=485193249116524544"
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/my/03points.vue